module.exports = __webpack_public_path__ + "img/super07.b191acb5.png";